import React from 'react';
import { Role } from '../../services/permissions/permissions.service';

interface RoleBadgeProps {
  role: Role | string;
  size?: 'sm' | 'md';
}

export function RoleBadge({ role, size = 'md' }: RoleBadgeProps) {
  const roleLabels: Record<string, string> = {
    OWNER: 'Proprietário',
    ADMIN: 'Administrador',
    MANAGER: 'Gerente',
    MEMBER: 'Membro',
    VIEWER: 'Visualizador',
  };

  const roleColors: Record<string, string> = {
    OWNER: 'bg-amber-500/10 text-amber-600 border-amber-200',
    ADMIN: 'bg-indigo-500/10 text-indigo-600 border-indigo-200',
    MANAGER: 'bg-emerald-500/10 text-emerald-600 border-emerald-200',
    MEMBER: 'bg-slate-500/10 text-slate-600 border-slate-200',
    VIEWER: 'bg-slate-300/10 text-slate-500 border-slate-200',
  };

  const label = roleLabels[role as string] ?? role;
  const colorClass = roleColors[role as string] ?? 'bg-slate-200/10 text-slate-500 border-slate-200';
  const sizeClass = size === 'sm' ? 'px-1.5 py-0.25 text-[8px]' : 'px-2 py-0.5 text-[10px]';

  return (
    <span
      className={`inline-flex items-center font-black rounded-md border ${sizeClass} uppercase tracking-wider ${colorClass}`}
    >
      {label}
    </span>
  );
}
